module.exports = __webpack_public_path__ + "img/el_farolito.fc86fd98.svg";